import { render, staticRenderFns } from "./Generales.vue?vue&type=template&id=19603449&scoped=true"
import script from "./Generales.vue?vue&type=script&lang=js"
export * from "./Generales.vue?vue&type=script&lang=js"
import style0 from "./Generales.vue?vue&type=style&index=0&id=19603449&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19603449",
  null
  
)

export default component.exports